import "./../../bindings/bao-searcher";
import "./../../bindings/log";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
/**
 * Explorer - Billing - Quickfilter
 */
class BillingQuickFilter {
    //observables
    BillingFolderIds = ko.observableArray([]);
    BillingFolderItems = ko.observable();
    BillingIds = ko.observableArray([]);
    BillingItems = ko.observable();
    //Name = ko.observable();
    explorerViewModel;
    constructor(explorerViewModel: any) {
        this.explorerViewModel = explorerViewModel;
        this.BillingFolderIds.subscribe(() => {
            this.SetQuickFilterObject();
            this.BaoSearcherBindingQuickfilterBillingsCustomFilter(this.GetBaoSearcherBindingQuickfilterBillingsCustomFilter());
        });
        this.BillingIds.subscribe(() => {
            this.SetQuickFilterObject();
        });
    }
    //functions
    SetQuickFilterObject = () => {
        var quickFilterObject = {
            BillingFolderIds: this.BillingFolderIds(),
            BillingIds: this.BillingIds()
        };
        this.explorerViewModel.QuickFilterJson(JSON.stringify(quickFilterObject));
    };
    BaoSearcherBindingQuickfilterBillingFolder: Bindings.baoSearcher = {
        ObjectId: <any>this.BillingFolderIds,
        ObjectValue: 'Name',
        SearchType: 'BillingFolder',
        AutoComplete: true,
        AutoSearch: true,
        SelectedItem: this.BillingFolderItems,
        MultiSelect: true
    };
    BaoSearcherBindingQuickfilterBillingsCustomFilter = ko.observable({});
    GetBaoSearcherBindingQuickfilterBillingsCustomFilter() {
        return { BillingFolderIds: JSON.stringify(ko.unwrap(this.BillingFolderIds)) };
    }
    BaoSearcherBindingQuickfilterBillings: Bindings.baoSearcher = {
        ObjectId: <any>this.BillingIds,
        ObjectValue: 'Description',
        SearchType: 'Billing',
        AutoComplete: true,
        AutoSearch: true,
        SelectedItem: this.BillingItems,
        MultiSelect: true,
        CustomFilter: this.BaoSearcherBindingQuickfilterBillingsCustomFilter
    };
    init() {
        return Bao.get("BillingQuickFilter/BillingQuickFilter")
            .then((template) => {
            this.explorerViewModel.QuickFilter(this);
            var templateName = "BillingQuickFilter";
            Bao.Templates[templateName] = template;
            this.explorerViewModel.QuickFilterTemplateName(templateName);
        });
    }
    ;
}
export default BillingQuickFilter;